export default __webpack_public_path__ + "static/media/personal-img.a2e96dc0.png";